// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1t-0r","type":"styles_type__3ubiC","choices":"styles_choices__NNujW"};